<template>
	<div>
		<el-dialog width="437px" :visible.sync="show" :append-to-body="true" @close="close()" @open="open()" :close-on-click-modal="false"
			:close-on-press-escape="false" :show-close="false">
			<div class="signin_dialog">
				<img @click="close()" class="signin_dialog_close_icon" src="../../../assets/icons/signin_close_icon.png"
					alt="" />
				<div class="signin_dialog_top">
					<div class="signin_dialog_top_title">
						<img @click="otpShow=false" class="signin_dialog_top_title_img"
							src="../../../assets/icons/signin_title.png" alt="" />
					</div>
					<div class="signin_dialog_top_remark">
						Claim rewards daily after logging In!
					</div>
				</div>
				<div class="signin_dialog_list" v-loading="loading">
					<!-- 全部领取完显示大遮罩 -->
					<div v-if="singData.signDay==7" class="signin_dialog_item_msk"></div>
					<div class="signin_dialog_item" v-for="(item,index) in singList" :key="item.signId"
						:class="`${(index+1)%3==0?'mar_r0':''}`" @click="singData.sign!=1?clickSing(item):''">
						<div v-if="index<singData.signDay" class="signin_dialog_item_msk"></div>
						<div class="signin_dialog_item_title">
							{{item.signName}}
						</div>
						<div class="signin_dialog_gift_icon_box">
							<img class="signin_dialog_gift_icon" src="../../../assets/icons/gift_icon1.png" alt="" />
							<div class="signin_dialog_gift_price">
								<img class="signin_dialog_gold_icon" src="../../../assets/icons/gold_icon.png" alt="" />
								₦ {{item.signNumber?item.signNumber:0}}
							</div>
						</div>
						
						<div class="signin_dialog_item_claim" v-if="index < singData.signDay"
							:class="singData.signDay>=index?'':'opacity0'">
							Claimed
						</div>
						<div class="signin_dialog_item_claim" v-if="singData.signDay==index&&!singData.sign"
							:class="singData.signDay>=index?'':'opacity0'">
							Claim
						</div>

					</div>
					<div v-if="singDay7.signNumber" class="signin_dialog_item_day7">
						<div class="signin_dialog_item_day7_left">
							<div class="signin_dialog_item_day7_left_title">
								{{singDay7.signName}}
							</div>
							<div class="signin_dialog_item_day7_price">
								<img class="signin_dialog_item_day7_price_icon"
									src="../../../assets/icons/gold_icon.png" alt="" />
								₦ {{singDay7.signNumber?singDay7.signNumber:0}}
							</div>
							<div v-if="singData.signDay==7||singData.signDay==6" class="signin_dialog_item_day7_claim">
								{{singData.signDay==6?'Claim':'Claimed'}}
							</div>
						</div>
						<img class="signin_dialog_item_day7_gift_icon" src="../../../assets/icons/gift_icon.png"
							alt="" />
					</div>
				</div>

			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { mapState } from 'vuex';
	export default {
		name: 'signinDialog',
		props: {
			show: {
				type: Boolean,
				default: false
			},
		},
		computed: {
			...mapState(['user']), // 映射 user 模块下的 userInfo 状态
		},
		data() {
			return {
				loading:false,
				
				singData: {
					sign: 0,
					signDay: 0,
					list: [],
				},
				singList: [],
				singDay7: {},
			}
		},
		mounted() {
			// this.open()
		},
		methods: {
			close() {
				this.$emit('close', false)
			},
			// 获取签到信息
			open() {
				this.loading = true
				this.$api.getSignInfo({}).then(res => {
					this.singList = []
					this.singData = res.data
					if (res.data.list.length > 0) {
						res.data.list.forEach((item, index) => {
							if (index < 6) {
								this.singList.push(item)
							}
						})
					}

					if (res.data.list.length > 6) {
						this.singDay7 = res.data.list[6]
					}
				}).finally(()=>{
					this.loading = false
				})
			},
			// 点击签到
			clickSing(value) {
				this.loading = true
				this.$api.signInfo({}).then(res => {
					this.singData.signDay = res.data.signDay
					this.singData.sign = 1
					this.$store.dispatch('GetInfo')
					// 每日签到埋点
					this.$track.track('dailySignInActivity',{
						userId:this.user.userId,
						reward:value.signNumber,
						currentDays:value.signId
						// consecutiveDays  连续签到的天数（待定）
					});
					this.$use.sendGoogleEvent('dailySignInActivity')
				}).finally(()=>{
					this.loading = false
				})
			},



		},
	}
</script>

<style scoped lang="scss">
	.signin_dialog {
		position: absolute;
		left: 0;
		top: 0;
		width: 440px;
		min-width: 437px;
		height: 705px;
		background: linear-gradient(230deg, #1C626A 0%, #052822 50%, #191300 100%);
		border-radius: 10px;
		border: 1px solid;
		box-sizing: border-box;
		padding: 60px 24px 32px;

	}

	.signin_dialog_top {
		text-align: center;
	}

	.signin_dialog_top_title {
		min-width: 267px;
		height: 27px;
		text-align: center;
	}

	.signin_dialog_top_title_img {
		width: 267px;
		height: 100%;
		margin: 0 auto;
	}

	.signin_dialog_close_icon {
		position: absolute;
		top: 19px;
		right: 19px;
		width: 32px;
		height: 32px;
		cursor: pointer;
	}

	.signin_dialog_top_remark {
		width: 100%;
		font-weight: 400;
		font-size: 16px;
		color: #CCFFC3;
		margin-top: 8px;
	}

	.signin_dialog_list {
		min-height: 520px;
		position: relative;
		margin-top: 20px;
		display: flex;
		align-items: center;
		flex-wrap: wrap;
	}

	.signin_dialog_item {
		position: relative;
		width: 124.39px;
		height: 159.7px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: space-between;
		background: linear-gradient(128deg, #172922 0%, #2C4F3B 50%, #55A373 100%);
		box-sizing: border-box;
		padding-top: 12px;
		margin: 18px 8px 0 0;
		border-radius: 3px;
		cursor: pointer;
	}

	.signin_dialog_item_msk {
		width: 100%;
		height: 100%;
		position: absolute;
		left: 0;
		top: 0;
		background: rgba(0, 0, 0, 0.4);
		border-radius: 3px;
		display: flex;
		align-items: center;
		justify-content: center;
		z-index: 1;
	}

	.signin_dialog_item_title {
		font-weight: bold;
		font-size: 15px;
		color: #E3FFBE;
	}

	.signin_dialog_gift_icon_box {
		position: relative;
		flex: 1;
		width: 87px;
		height: 87px;
		margin-top: 5px;
	}

	.signin_dialog_gift_icon {
		width: 100%;
	}

	.signin_dialog_gift_price {
		position: absolute;
		width: 100%;
		left: 50%;
		transform: translateX(-50%);
		bottom: 8px;
		font-weight: bold;
		font-size: 15px;
		color: #97FF51;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.signin_dialog_gold_icon {
		width: 19px;
		height: 18px;
		margin-right: 3px;
	}

	.signin_dialog_item_claim {
		width: 124px;
		height: 27px;
		background: linear-gradient(118deg, #B2EB14 0%, #17CB67 25%, #19AB89 100%);
		border-radius: 0px 0px 3px 3px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-weight: bold;
		font-size: 15px;
		color: #FFFFFF;
	}

	.signin_dialog_item_day7 {
		position: relative;
		width: 387px;
		height: 148px;
		background: linear-gradient(169deg, rgba(25, 38, 37, 0.6) 0%, #55A373 99%);
		border-radius: 6px;
		margin-top: 26px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		cursor: pointer;
	}

	.signin_dialog_item_day7_left {
		font-weight: bold;
		font-size: 15px;
		color: #E3FFBE;
		margin-left: 24px;
	}

	.signin_dialog_item_day7_left_title {
		min-width: 100px;
	}

	.signin_dialog_item_day7_price {
		color: #14EB74;
		font-size: 21px;
		display: flex;
		align-items: center;
		margin-top: 18px;
	}

	.signin_dialog_item_day7_price_icon {
		width: 26.56px;
		height: 24.46px;
		margin-right: 5px;
	}

	.signin_dialog_item_day7_gift_icon {
		position: absolute;
		right: -5px;
		bottom: -10px;
		width: 187px;
		height: 186px;
	}

	.signin_dialog_item_day7_claim {
		width: 92px;
		height: 24px;
		background: linear-gradient(118deg, #B2EB14 0%, #17CB67 25%, #19AB89 100%);
		border-radius: 6px 6px 6px 6px;
		font-size: 12px;
		margin-top: 6px;
	}
</style>